// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-5bc3281e]{margin-bottom:80px}[data-v-5bc3281e] .el-table .cell{word-break:inherit!important}[data-v-5bc3281e] .el-form-item__label{font-size:16px}", ""]);
// Exports
module.exports = exports;
